import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Select, CircularProgress,
  Table,TableHead,TableRow,TableCell,
  MenuItem, FormControl, InputLabel, Grid } from '@mui/material';
import axios from '../../../Axiosinstance';
import Slots from './Slots'; // Import the Slots component

function Book({ onSearch }) {
  const [initiative, setInitiative] = useState('');
  const [location, setLocation] = useState('');
  const [course, setCourse] = useState('');
  const [language, setLanguage] = useState('');
  const [initiatives, setInitiatives] = useState([]);
  const [venues, setVenues] = useState([]);
  const [courses, setCourses] = useState([]); 
  const [languages, setLanguages] = useState([]);
  const [showSlots, setShowSlots] = useState(false);
  const [courseDetails, setCourseDetails] = useState(null); // State for course details
  const [loading, setLoading] = useState(true); // Loading state for API calls
  const [error, setError] = useState(''); // Error state

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [initiativesResponse, venuesResponse] = await Promise.all([
          axios.get('/categories/findall'),
          axios.get('/wsq/venues/finalls')
        ]);
        setInitiatives(initiativesResponse.data);
        setVenues(venuesResponse.data);
      } catch (error) {
        console.error('Error fetching data:', error);
        setError('Failed to load initiatives or venues. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleInitiativeChange = async (event) => {
    const selectedInitiative = event.target.value;
    setInitiative(selectedInitiative);

    const selectedInitiativeData = initiatives.find(i => i.name === selectedInitiative);
    const categoryId = selectedInitiativeData ? selectedInitiativeData.id : null;

    if (categoryId) {
      try {
        const response = await axios.get(`/wsq/courses/by-category?categoryId=${categoryId}`);
        setCourses(response.data);
        setLanguages([]);
      } catch (error) {
        console.error('Error fetching courses:', error);
      }
    }
  };

  const handleCourseChange = (event) => {
    const selectedCourse = event.target.value;
    setCourse(selectedCourse);

    const selectedCourseData = courses.find(c => c.name === selectedCourse);
    setLanguages(selectedCourseData ? selectedCourseData.languages : []);
  };

  const handleLocationChange = (event) => {
    setLocation(event.target.value);
  };

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };

  const handleSearchClick = async () => {
    setShowSlots(true);
    onSearch({ initiative, location, course, language });

    // Fetch course details using the selected course
    const selectedCourseData = courses.find(c => c.name === course);
    if (selectedCourseData && selectedCourseData.id) {
      try {
        const response = await axios.get(`/wsq/courses/${selectedCourseData.id}`);
        setCourseDetails(response.data);
      } catch (error) {
        console.error('Error fetching course details:', error);
        setError('Failed to load course details. Please try again.');
      }
    }
  };

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Box sx={{ padding: '30px', backgroundColor: '#f9f9f9', fontFamily: 'Arial, sans-serif', maxWidth: '1200px', margin: '0 auto', borderRadius: '10px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}>
      {error && <Typography color="error">{error}</Typography>}
      <Grid container spacing={6}>
        <Grid item xs={12} md={6}>
          <Box sx={{ paddingRight: '20px' }}>
            <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold', marginBottom: '20px', color: '#333' }}>
              Bookings
            </Typography>
            <Typography variant="body1" component="p" sx={{ marginBottom: '20px', lineHeight: 1.6 }}>
              Jurong Academy (Academy of Design Arts & Media) is a part of Summit Global, offering specialized courses.
            </Typography>
            <Typography variant="body1" component="p" sx={{ marginBottom: '20px', lineHeight: 1.6 }}>
              Please click <a href="#" style={{ color: '#007BFF', textDecoration: 'underline' }}>here</a> for courses under Design, Arts & Media and Aerial Drone.
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box sx={{ backgroundColor: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)' }}>
            <FormControl fullWidth sx={{ marginBottom: '20px' }}>
              <InputLabel id="initiative-label">Select Initiative</InputLabel>
              <Select
                labelId="initiative-label"
                id="initiative-select"
                value={initiative}
                label="Select Initiative"
                onChange={handleInitiativeChange}
              >
                <MenuItem value="">Select Initiative</MenuItem>
                {initiatives.map((initiative) => (
                  <MenuItem key={initiative.id} value={initiative.name}>
                    {initiative.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

           

            <FormControl fullWidth sx={{ marginBottom: '20px' }}>
              <InputLabel id="course-label">Select Course</InputLabel>
              <Select
                labelId="course-label"
                id="course-select"
                value={course}
                label="Select Course"
                onChange={handleCourseChange}
              >
                <MenuItem value="">Select Course</MenuItem>
                {courses.map((course) => (
                  <MenuItem key={course.id} value={course.name}>
                    {course.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth sx={{ marginBottom: '20px' }}>
              <InputLabel id="language-label">Select Language</InputLabel>
              <Select
                labelId="language-label"
                id="language-select"
                value={language}
                label="Select Language"
                onChange={handleLanguageChange}
              >
                <MenuItem value="">Select Language</MenuItem>
                {languages.map((lang, index) => (
                  <MenuItem key={index} value={lang}>
                    {lang}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth sx={{ marginBottom: '20px' }}>
              <InputLabel id="location-label">Select Location</InputLabel>
              <Select
                labelId="location-label"
                id="location-select"
                value={location}
                label="Select Location"
                onChange={handleLocationChange}
              >
                <MenuItem value="">Select Location</MenuItem>
                {venues.map((venue) => (
                  <MenuItem key={venue.id} value={venue.place || ''}>
                    {venue.place || 'Unknown Location'}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button
              variant="contained"
              sx={{
                width: '100%',
                height: '45px',
                backgroundColor: '#007BFF',
                color: '#fff',
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: '#0056b3',
                },
              }}
              onClick={handleSearchClick}
            >
              SEARCH
            </Button>
          </Box>
        </Grid>
      </Grid>

      {courseDetails && (
  <Box sx={{ marginTop: '30px', padding: '20px', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)' }}>
<Typography 
  variant="h6" 
  component="p" 
  sx={{ marginBottom: '10px' }}
>
  <a>Course Title:</a>
  <span 
    style={{ 
      fontSize: '22px',    // Increase font size
      color: '#2186C8',       // Set text color to blue
      fontWeight: 'bold',  // Make font bold
      display: 'block'     // Ensure it starts on the next line
    }}
  >
    {courseDetails.name}
  </span>
</Typography>


<Typography 
  variant="h6" 
  component="p" 
  sx={{ marginBottom: '10px' }}
>
  <a>Fee:</a>
  <span 
    style={{ 
      fontSize: '22px',    // Increase font size
      color: '#2186C8',       // Set text color to blue
      fontWeight: 'bold',  // Make font bold
      display: 'block'     // Ensure it starts on the next line
    }}
  >
     {courseDetails.fee} 
  </span>
</Typography>



    <Box sx={{ backgroundColor: '#d5d5d5', padding: '10px', borderRadius: '4px' }}>
  <Typography variant="body1" component="p" sx={{ marginBottom: '10px' }}>
    <strong>Course Aim:</strong> 
    <span dangerouslySetInnerHTML={{ __html: courseDetails.courseAim }} />
  </Typography>
</Box>

<br />
<Box sx={{ backgroundColor: '#2186C8', padding: '10px', borderRadius: '4px' }}>
  <Typography variant="h6" component="p" sx={{ marginBottom: '10px' , color: 'white'  }}>
    <strong></strong> 
    <span dangerouslySetInnerHTML={{ __html: courseDetails.ps }} />
  </Typography>
</Box>
<br />
<Box sx={{ backgroundColor: '#d5d5d5', padding: '10px', borderRadius: '4px' }}>
    <Typography variant="body1" component="p" sx={{ marginBottom: '10px' }}>
      <strong style={{ fontSize: '24px', color: '#2186C8' }}>Entry Requirement:</strong>

      <span dangerouslySetInnerHTML={{ __html: courseDetails.entryRequirement }} />
    </Typography>
    </Box>
<br />
<br />


<Typography 
  variant="h6" 
  component="p" 
  sx={{ marginBottom: '10px' }}
>
  <a>Course Duration:</a>
  <span 
    style={{ 
      fontSize: '22px',    // Increase font size
      color: '#2186C8',       // Set text color to blue
      fontWeight: 'bold',  // Make font bold
      display: 'block'     // Ensure it starts on the next line
    }}
  >
   {courseDetails.courseDuration} hours
  </span>
</Typography>

<Typography 
  variant="h6" 
  component="p" 
  sx={{ marginBottom: '10px' }}
>
  <a>Course Location:</a>
  <span 
    style={{ 
      fontSize: '22px',    // Increase font size
      color: '#2186C8',       // Set text color to blue
      fontWeight: 'bold',  // Make font bold
      display: 'block'     // Ensure it starts on the next line
    }}
  >
  {courseDetails.courseLocation}
  </span>
</Typography>


<Typography 
  variant="h6" 
  component="p" 
  sx={{ marginBottom: '10px' }}
>
  <a>Course Attendance Record:</a>
  <span 
    style={{ 
      fontSize: '22px',    // Increase font size
      color: '#2186C8',       // Set text color to blue
      fontWeight: 'bold',  // Make font bold
      display: 'block'     // Ensure it starts on the next line
    }}
  >
  {courseDetails.courseAttendanceRecord}
  </span>
</Typography>




   <Typography variant="h6" component="h4" sx={{ fontWeight: 'bold', marginTop: '20px', marginBottom: '10px' }}>
      Assessment Criteria
    </Typography>
    {courseDetails.assessmentCriteria && (
  <Table sx={{ marginBottom: '20px' }}>
    <TableHead>
      <TableRow>
        <TableCell sx={{ backgroundColor: '#2186C8', color: 'white', fontWeight: 'bold' }}>Mode of Training</TableCell>
        <TableCell sx={{ backgroundColor: '#2186C8', color: 'white', fontWeight: 'bold' }}>Mode</TableCell>
        <TableCell sx={{ backgroundColor: '#2186C8', color: 'white', fontWeight: 'bold' }}>Method</TableCell>
        <TableCell sx={{ backgroundColor: '#2186C8', color: 'white', fontWeight: 'bold' }}>Duration (hours)</TableCell>
        <TableCell sx={{ backgroundColor: '#2186C8', color: 'white', fontWeight: 'bold' }}>Passing Criteria</TableCell>
      </TableRow>
    </TableHead>
    <tbody>
      {courseDetails.assessmentCriteria.map((criteria, index) => (
        <TableRow key={index}>
          <TableCell>{criteria.modeOfTrainingForAssessment}</TableCell>
          <TableCell>{criteria.mode}</TableCell>
          <TableCell>{criteria.method}</TableCell>
          <TableCell>{criteria.duration} hours</TableCell>
          <TableCell>{criteria.passingCriteria}</TableCell>
        </TableRow>
      ))}
    </tbody>
  </Table>
)}



{courseDetails.languages && (
  <Table sx={{ marginBottom: '20px' }}>
    <TableHead>
      <TableRow>
        <TableCell sx={{ backgroundColor: '#2186C8', color: 'white', fontWeight: 'bold' , textAlign: 'center' }}>Languages</TableCell>
      </TableRow>
    </TableHead>
    <tbody>
      <TableRow>
        <TableCell sx={{ textAlign: 'center' }}>{courseDetails.languages.join(', ')}</TableCell>
      </TableRow>
    </tbody>
  </Table>
)}

     </Box>
)}


      {showSlots && (
        <Box sx={{ marginTop: '20px' }}>
          <Slots 
            initiative={initiative} 
            location={location} 
            course={course} 
            language={language} 
          />
        </Box>
      )}

 
    </Box>
  );
}

export default Book;
